export default __webpack_public_path__ + "static/less-8d3aed589e55e6a43a021c523fb1f829.png";